import { ILoggingService } from './loggingService';

export enum ConnectionStatus { "Unknown", "Starting", "Connected", "Disconnected" };

export interface IConnectionMonitorService {
    heartbeatSuccess(): any;
    heartbeatError(): any;
    subscribeConnectionStatusChange(callback: (connectionStatus: ConnectionStatus) => void): any;
    setHeartbeatService(hearbeatService: IHeartbeatService): any;
    requestSuccess(): any;
}

export interface IHeartbeatService {
    forceCheckAsync(): Promise<void>;
}

//https://caniuse.com/#feat=online-status
//https://stackoverflow.com/questions/3181080/how-to-detect-online-offline-event-cross-browser
//https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/Online_and_offline_events

export function createConnectionMonitorService(connectionTimeoutMs: number, heartbeatService: IHeartbeatService, loggingService: ILoggingService): IConnectionMonitorService {

    let lastSuccessTs = 0;
    let connectionStatus = ConnectionStatus.Starting;
    let callbacks: any[] = [];

    const heartbeatSuccess = () => {
        lastSuccessTs = new Date().getTime();
        if (connectionStatus == ConnectionStatus.Starting || connectionStatus == ConnectionStatus.Disconnected) {
            connectionStatus = ConnectionStatus.Connected;
            notify();
        }
    }

    const requestSuccess = () => {
        if (connectionStatus === ConnectionStatus.Disconnected) {  //to avoid init problems
            heartbeatSuccess();
        }
    }

    const heartbeatError = () => {
        loggingService.warning("heartbeatError");
        if (connectionStatus != ConnectionStatus.Disconnected) {
            var currentTs = new Date().getTime();
            if (currentTs - lastSuccessTs > connectionTimeoutMs) {
                setDisconnected();
            }
        }
    }

    const setDisconnected = () => {
        connectionStatus = ConnectionStatus.Disconnected;
        notify();
    }

    const notify = () => {
        callbacks.forEach((callback) => {
            callback(connectionStatus);
        });
    }

    const subscribeConnectionStatusChange = (callback: (connectionStatus: ConnectionStatus) => void) => {
        callbacks.push(callback);
    }

    const handleConnectionChange = () => {
        if (navigator.onLine) {
            if (connectionStatus != ConnectionStatus.Connected) {
                if (heartbeatService) {
                    heartbeatService.forceCheckAsync();
                }
            }
            return;
        }

        setDisconnected();
    }

    const setHeartbeatService = (aHearbeatService: IHeartbeatService) => {
        heartbeatService = aHearbeatService;
    }

    window.addEventListener('online', handleConnectionChange);
    window.addEventListener('offline', handleConnectionChange);

    return {
        heartbeatSuccess,
        heartbeatError,
        subscribeConnectionStatusChange,
        setHeartbeatService,
        requestSuccess
    };
}
